import 'jquery-form';
import 'jquery-validation';
import '../validator-rules'
import ssoTool from "../tools/sso.tool";
import ssoAlert from "../tools/sso.alert";
import ssoAjax from "../tools/sso.ajax";
import Swal from "sweetalert2";

export function init() {
    const passwordResetForm = $('#password_reset_form');
    const btnSubmit = $('#btn_submit');

    ssoTool.setInputEyeSwitch('#target_user_password');
    ssoTool.setInputEyeSwitch('#target_user_password_confirm');

    passwordResetForm.validate({
        showErrors: function () {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function (form) {
            ssoAlert.fire({
                html: `
                        <h4>${language.business_manager.reset_password.input_modifier_password}</h4>
                        <input class="form-control" id="business_manager_password">
                    `,
                footer: `
                    <a href="#" id="btn_submit_reset_form" class="ms-1 btn btn-primary me-4 text-white w-100 fw-bold">${globalLanguage.ok}</a>
                    <a href="#" id="btn_close_sso_alert" class="me-2 btn border border-1 border-primary text-black w-100 fw-bold">${globalLanguage.cancel}</a>
                    `,
                didRender: function () {
                    $('#btn_submit_reset_form').on('click', function () {
                        const businessManagerPassword = $('#business_manager_password');

                        if (businessManagerPassword.val() === '') {
                            return false;
                        }

                        $('#operator_password').val(businessManagerPassword.val());

                        ssoAjax.submit(form, function (response) {
                            try {
                                if (response.status === false) {
                                    throw new Error(response.message);
                                }

                                ssoAlert.success(language.password_reset);

                                $(form).resetForm();
                            } catch (e) {
                                ssoAlert.error(e.message);
                            }

                            ssoAjax.btnSetToSubmit();
                        })

                        return false;
                    });

                    $('#btn_close_sso_alert').on('click', function () {
                        Swal.close();

                        return false;
                    });
                }
            });
        }
    });

}
